<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Upload CSS file">
            <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="show">
            <b-form-file
                v-model="file"
                :state="Boolean(file)"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here...">
            </b-form-file>
            <b-form-group v-if="!disabled" class="mt-3" v-on:select="chechIfFileExist">Selected file: {{ file ? file.name : '' }}</b-form-group>
            <b-alert v-if="disabled" show variant="danger">{{ file.name }} already exist!</b-alert>

            <b-form-group>
                <b-button type="submit" :disabled="disabled" variant="primary">Upload</b-button>
                <b-button type="reset" variant="danger">Reset</b-button>
            </b-form-group>
            <b-form-group>
              <transition name="slide-fade" mode="in-out">
                <b-alert v-if="uploaded" show variant="success">{{ file.name }} uploaded!</b-alert>
              </transition>
            </b-form-group>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      file: null,
      available_files: [],
      show: true,
      disabled: false,
      uploaded: false
    }
  },
  watch: {
    file (value) {
      if (value != null) {
        // binding this to the data value in the email input
        this.file = value
        this.chechIfFileExist(value.name)
      }
    }
  },
  methods: {
    chechIfFileExist (filename) {
      // verify if file exist
      let available = []
      available = (this.available_files.filter(file => file.name === filename))
      if (available.length === 0) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    onSubmit (evt) {
      if (this.file) {
        // Initialize the form data
        const formData = new FormData()
        /*
            Add the form data we need to submit
          */
        formData.append('file', this.file)
        this.$http.post(`${this.$api_url}/uploadCSS`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then((data) => {
          this.uploaded = true
          const uploadSuccess = setTimeout(() => {
            this.onReset()
            clearTimeout(uploadSuccess)
          }, 3000)
        })
      }
    },
    onReset () {
      // Reset our form values
      this.file = null
      this.show = false
      this.disabled = false
      this.uploaded = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    loadCSSList () {
      this.$http.get(`${this.$api_url}/scandircss`).then((data) => {
        if (data) {
          // const dir = data.data.dir
          this.available_files = data.data.data
        }
      })
    }
  },

  mounted () {
    this.loadCSSList()
  }
}
</script>

<style scoped>
  .slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
